<template>
    <footer class="container">
        <div class="space-left d-block justify-content-start">
            <div>
                <h4>{{ cms.footerHead }}</h4>
                <p>{{ cms.footerText1 }} <b>{{ cms.footerText2 }}</b> {{ cms.footerText3 }}</p>
            </div>
            <div>
                <h4>{{ cms.footerCtc }}</h4>
                <ul>
                    <li><a :href="'mailto:' + cms.footerMail" class="plain-link">{{ cms.footerMail }}</a></li>
                    <li><a :href="'//' + cms.footerQuestion" class="plain-link"
                            target="_blank">{{ cms.footerQuestion }}</a></li>
                </ul>
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        data() {
            return {
                /* eslint-disable */
                cms: {
                    footerHead: FOOTER_HEAD,
                    footerText1: FOOTER_TXT1,
                    footerText2: FOOTER_TXT2,
                    footerText3: FOOTER_TXT3,
                    footerCtc: FOOTER_CTC,
                    footerMail: FOOTER_MAIL,
                    footerQuestion: FOOTER_QUESTION
                }
                /* eslint-enable */
            }
        }
    }
</script>